import React, { FC } from 'react'

type TabKeys = string

interface Props {
  className?: string
  selected: string
  tabs: Record<TabKeys, string>
  onSelect: (tab: TabKeys) => void
}

const Tabs: FC<Props> = ({ className, tabs, selected, onSelect }) => {
  return (
    <div className={`tabs ${className}`}>
      {Object.entries(tabs).map(([tab, label]) => (
        <button
          key={`tab-${tab}`}
          type="button"
          className={`tabs__button ${tab === selected ? 'tabs__button--selected' : ''} btn btn-outline-secondary`}
          onClick={() => onSelect?.(tab)}
        >
          {label}
        </button>
      ))}
    </div>
  )
}

export default Tabs
